import { Component, OnInit, ViewChild, Inject, ElementRef } from '@angular/core';
import { MatDialogRef, MatTableDataSource, MatSort, MAT_DIALOG_DATA, MatDialog } from '@angular/material';

import { ApplicationConstants } from '../../providers/application-constants';
import { Utils } from '../../providers/utils';
import { QueryList } from '../../providers/query-list';
import { element } from 'protractor';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-stock-inventory',
  templateUrl: './stock-inventory.component.html',
  styleUrls: ['./stock-inventory.component.css']
})
export class StockInventoryComponent implements OnInit {

  public menu_item_id = '67';
  public edit_auth;

  private dp = [];
  branchList = [];
  storeList = [];
  allStoreList = [];

  displayedColumns = ['sub_item_no', 'main_item_name', 'main_item_name_en', 'item_cat_name',
    'item_subcat_name', 'store_name', 'stock_no', 'quantity', 'expiry_date', 'available_count'];

  dataSource = new MatTableDataSource(this.dp);
  @ViewChild(MatSort) sort: MatSort;

  model = { 'table_name': 'stock_base', 'branch_id': '0', 'store_id': '0', 'sub_item_no': '', 
    'title': 'جرد المخزون' }; 

  search_obj = {
    'placeholder': 'اسم/ رقم الصنف', 'class_name': 'longSearchField',
    'table_list': [{
      'table_name': '`main_item`', 'selected_no': 'sub_item_no',
      'field_list': ['main_item_name', 'main_item_name_en'],
      'join_table': '`sub_item`',
      'join_field_list': ['sub_item_no'],
      'join_condition': ' AND `main_item`.`main_item_id` = `sub_item`.`main_item_id`'
    }]
  };

  Store_Msg; Sub_Item_Msg; Sub_item_Placeholder; Stock_Inventory;
  Success_Msg; Error_Msg; Branch_Msg;

  constructor(private utils: Utils, public applicationConstants: ApplicationConstants,
    private queryList: QueryList, public dialog: MatDialog, public translate: TranslateService) {
    this.getMessages(translate);
  }

  getMessages(translate) {

    translate.setDefaultLang(this.applicationConstants.user_lang);
    translate.use(this.applicationConstants.user_lang);

    translate.get('Sub_item_Placeholder').subscribe((res: string) => {
      this.Sub_item_Placeholder = res;
    });
    this.search_obj['placeholder'] = this.Sub_item_Placeholder;

    translate.get('Branch_Msg').subscribe((res: string) => {
      this.Branch_Msg = res;
    });

    translate.get('Store_Msg').subscribe((res: string) => {
      this.Store_Msg = res;
    });

    translate.get('Sub_Item_Msg').subscribe((res: string) => {
      this.Sub_Item_Msg = res;
    });

    translate.get('Stock_Inventory').subscribe((res: string) => {
      this.Stock_Inventory = res;
    });
    this.model['title'] = this.Stock_Inventory;

    translate.get('Success_Msg').subscribe((res: string) => {
      this.Success_Msg = res;
    });

    translate.get('Error_Msg').subscribe((res: string) => {
      this.Error_Msg = res;
    });

  }

  ngOnInit() {
    this.edit_auth = this.utils.getAuth(this.menu_item_id, this.applicationConstants.EDIT_AUTH);

    let query = "SELECT DISTINCT `branch`.* FROM `branch`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `branch`.`branch_id` AND `branch`.`status` = '1' AND `branch_auth`.`status` = '1'" +
      " AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'";
    let obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        
        this.branchList = data.data['list'];
        this.branchList.unshift({ 'branch_id': '0', 'branch_name': 'اختر', 'branch_name_en': 'Select' });
      });

    query = "SELECT `store`.* FROM `store`, `branch_auth` WHERE `branch_auth`.`branch_id` =" +
      " `store`.`branch_id` AND `store`.`status` = '1' AND `branch_auth`.`status` = '1' AND" +
      " `branch_auth`.`branch_id` = '" + this.applicationConstants.user_branch_info.user_branch_id +
      "' AND `branch_auth`.`user_id` = '" + this.applicationConstants.user_info.user_id + "'" +
      " AND `branch_auth`.`store_id` = `store`.`store_id`";

    obj = { cmd: 'getList', query: query };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        this.allStoreList = data.data['list'];
      });

  }

  filterStore() {
    this.storeList = [{ 'store_id': '0', 'store_name': 'اختر', 'store_name_en': 'Select' }];
    this.model['store_id'] = '0';

    if (this.model['branch_id'] != '0') {
      this.allStoreList.forEach(element => {
        if (element.branch_id == this.model['branch_id'])
          this.storeList.push(element);
      });
    }
  }

  onChangeSearch = function (search_result: object) {
    console.log(search_result);
    this.model['sub_item_no'] = search_result['no'];
  }

  search() {
    if (this.model['branch_id'] == '0') {
      alert(this.Branch_Msg);
      return false;
    }

    if (this.model['store_id'] == '0') {
      alert(this.Store_Msg);
      return false;
    }

    if (this.model['sub_item_no'] == '') {
      alert(this.Sub_Item_Msg);
      return false;
    }

    let obj = {
      cmd: 'getStockList', store_id: this.model['store_id'], sub_item_no: this.model['sub_item_no'], 
      cost_per_unit: '1'
    };

    this.utils.invokeHttp(this.applicationConstants.saleFuncFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();

        this.dp = data.status.msg;
        this.dataSource = new MatTableDataSource(this.dp);
        this.dataSource.sort = this.sort;
        console.log(this.dp);
      });
  }

  save() {
    let available_count;
    let base_date = new Date().getFullYear() + '-' + (new Date().getMonth() + 1) + '-' + new Date().getDate()
      + ' ' + new Date().getHours() + ':' + new Date().getMinutes() + ':' + new Date().getSeconds()
    let values = [];

    this.dp.forEach(element => {
      available_count = (document.getElementById('available_count_' + element.stock_id) as HTMLInputElement).value;

      values.push({
        'table_name': this.model['table_name'], 'sub_item_number': element.primary_sub_item_number,
        'stock_no': element.stock_no, 'base_date': base_date, 'store_id': element.store_id, 'is_manual': '1',
        'source': 'stock_inventory',
        'baseline_amount': (Number(available_count) * Number(element.primary_qty)).toFixed(2),
        'book_qty': '0', 'cost_per_unit': element.cost_per_unit, 'invoice_no': element.invoice_no,
        'production_no': element.production_no
      });

      if (element.expiry_date != '' && element.expiry_date != null)
        values[values.length - 1]['expiry_date'] = element.expiry_date;

    });

    console.log(values);
    let obj = { cmd: 'add', values: values };
    this.utils.invokeHttp(this.applicationConstants.generalFile, obj)
      .subscribe(data => {
        this.applicationConstants.appComp.hideBusyCursor();
        if (data.status['type'] == 'success') {
          alert(this.Success_Msg);
          this.search();
        }
        else
          alert(this.Error_Msg);
      });
  }

}
